import { render } from "./OTPVerification.vue?vue&type=template&id=38cbfb59"
import script from "./OTPVerification.vue?vue&type=script&lang=js"
export * from "./OTPVerification.vue?vue&type=script&lang=js"

import "./OTPVerification.vue?vue&type=style&index=0&id=38cbfb59&lang=css"
script.render = render

export default script